import { render, staticRenderFns } from "./SideMenuOptions.vue?vue&type=template&id=c24a664c&scoped=true&"
import script from "./SideMenuOptions.vue?vue&type=script&lang=js&"
export * from "./SideMenuOptions.vue?vue&type=script&lang=js&"
import style0 from "./SideMenuOptions.vue?vue&type=style&index=0&id=c24a664c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c24a664c",
  null
  
)

export default component.exports